import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays a description specific to the selected product variant.
 *
 * @extends Component
 */
export default class ProductVariantDescription extends Component {
  #boundHandleVariantUpdate = this.#handleVariantUpdate.bind(this);

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.#boundHandleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.#boundHandleVariantUpdate);
  }

  /**
   * @param {CustomEvent} event
   */
  #handleVariantUpdate(event) {
    const { resource, data } = event.detail;
    if (!resource) return;

    if (data?.productId && this.dataset.productId && data.productId !== this.dataset.productId) {
      return;
    }

    const items = this.querySelectorAll('[data-variant-id]');
    items.forEach((item) => {
      item.hidden = item.dataset.variantId !== String(resource.id);
    });
  }
}

if (!customElements.get('product-variant-description')) {
  customElements.define('product-variant-description', ProductVariantDescription);
}
